import { SET_SOURCE_ACCOUNT } from '../actions/sourceAccount';

const initialState = {
  sourceAccount: null,
};

const SourceAccountReducer = (state = initialState, action = {}) => {
  if (action.type === SET_SOURCE_ACCOUNT) {
    return {
      ...state,
      sourceAccount: action.payload,
    };
  }

  return state;
};

export default SourceAccountReducer;
